import React from 'react';
import styles from './SocialShareLinkBox.scss';
import { useOptimizely } from '../../hooks';
import { Experiments } from '../../constants/experiments';
import { TikTokIcon } from '../SocialIcons/TikTokIcon';
import { YoutubeIcon } from '../SocialIcons/YoutubeIcon';
import { SlackIcon } from '../SocialIcons/SlackIcon';
import { TeamsIcon } from '../SocialIcons/TeamsIcon';
import { LinktreeIcon } from '../SocialIcons/LinktreeIcon';
import { SnapchatIcon } from '../SocialIcons/SnapchatIcon';
import { RedditIcon } from '../SocialIcons/RedditIcon';
import { TwitchIcon } from '../SocialIcons/TwitchIcon';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import { gql } from '@apollo/client';
import { SocialShareLinkOwnerFragment } from '../../../types/__generated__';
import { SocialsIconsShareWrapper } from '../SocialIcons/SocialIconsShareWrapper';
import { useTranslation } from 'react-i18next';

export interface SocialShareLinkBoxProps {
  onShareItemClick?: () => void;
}

const FRAGMENT = buildQuery(gql`
  fragment SocialShareLinkOwner on Page {
    owner {
      id
      name
      avatar
    }
  }
`);

export const SocialShareLinkBox: React.FunctionComponent<SocialShareLinkBoxProps> = ({
  onShareItemClick,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const result = usePageQuery<SocialShareLinkOwnerFragment>(FRAGMENT);

  const name = result.data?.owner?.name ?? '';
  const optimizely = useOptimizely();

  function onShare() {
    if (optimizely) {
      optimizely.track(Experiments.TrackingEvents.shareSocialButtonClick);
    }

    if (onShareItemClick) {
      onShareItemClick();
    }
  }

  return (
    <div className={styles.container}>
      <p className={styles.shareBoxTitle}>
        {t('fundraising.SocialShareLinkBoxTitle', {
          name: name,
        })}
      </p>
      <div>
        <ul className={styles.socialIconList} data-qa="SocialIconShareList">
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<TikTokIcon />}
              socialChannel={'tiktok'}
              onClick={onShare}
            />
          </li>{' '}
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<YoutubeIcon />}
              socialChannel={'youtube'}
              onClick={onShare}
            />
          </li>{' '}
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<SlackIcon />}
              socialChannel={'slack'}
              onClick={onShare}
            />
          </li>{' '}
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<TeamsIcon />}
              socialChannel={'teams'}
              onClick={onShare}
            />
          </li>{' '}
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<LinktreeIcon />}
              socialChannel={'linktree'}
              onClick={onShare}
            />
          </li>{' '}
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<SnapchatIcon />}
              socialChannel={'snapchat'}
              onClick={onShare}
            />
          </li>{' '}
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<RedditIcon />}
              socialChannel={'reddit'}
              onClick={onShare}
            />
          </li>
          <li className={styles.listItem} data-qa="SocialIconShareListItem">
            <SocialsIconsShareWrapper
              children={<TwitchIcon />}
              socialChannel={'twitch'}
              onClick={onShare}
            />
          </li>
        </ul>
      </div>
    </div>
  );
};
